// Identifier keys the Entity Filter popup knows, in tab order. Each one is also a
// digital twin list column, a list filter argument and a search-suggestions key.
export const ENTITY_FILTER_KEYS = ["licensePlateNo", "deviceID", "vin", "customerBatteryID"];

// Tabs shown when the org configures none. customerBatteryID is opt-in, since most
// orgs leave it empty.
export const DEFAULT_ENTITY_FILTER_KEYS = ["licensePlateNo", "deviceID", "vin"];

/**
 * Keys of the tabs to show: the org's advancedAnalysis.entityTypes that this popup
 * knows, in that order, else DEFAULT_ENTITY_FILTER_KEYS. A configured key this popup
 * does not know is skipped, since a tab with no values would break the popup.
 */
export const resolveEntityFilterKeys = (entityTypes) => {
    const configured = Array.isArray(entityTypes)
        ? entityTypes.filter((key) => ENTITY_FILTER_KEYS.includes(key))
        : [];
    return configured.length > 0 ? configured : DEFAULT_ENTITY_FILTER_KEYS;
};

/**
 * Tabs for the Advanced Analysis Entity Filter popup: { [key]: { key, label, values } },
 * values pre-filled from the first page of the digital twin list. Tabs follow
 * resolveEntityFilterKeys.
 *
 * @param {object} args
 * @param {object} args.labels          - { [key]: tab label }
 * @param {Array}  [args.digitalTwinList] - list rows with batteryID and the tab keys
 * @param {Array}  [args.entityTypes]   - advancedAnalysis.entityTypes from page meta
 */
export const buildEntityFilterOptions = ({ labels, digitalTwinList = [], entityTypes = [] }) => {
    const options = {};
    resolveEntityFilterKeys(entityTypes).forEach((key) => {
        options[key] = {
            key,
            label: labels?.[key] || key,
            values: digitalTwinList.map((digitalTwin) => ({
                id: digitalTwin?.batteryID,
                value: digitalTwin?.[key],
            })),
        };
    });
    return options;
};
